import { store } from '@utils/configStore'
import storeMarksReducer from './slices'

export const injectStoreMarks = () => store.injectReducer('storeMarks', storeMarksReducer)
